// Branch locations data

export const branches = [
  {
    id: 1,
    country: 'United Kingdom',
    countryAr: 'المملكة المتحدة',
    city: 'London (Harrow)',
    cityAr: 'لندن (هارو)',
    address: '25 Masons Avenue, Harrow HA3 5AH',
    addressAr: '٢٥ شارع ميسونز، هارو HA3 5AH',
    phone: '+44 20 8189 8889',
    whatsapp: '+442081898889',
    email: 'london@harryandjacobs.com',
    flag: '🇬🇧',
    isHeadquarters: true,
    hours: {
      en: 'Mon-Fri: 9:00 AM - 6:00 PM, Sat: 10:00 AM - 4:00 PM',
      ar: 'الإثنين-الجمعة: ٩ص - ٦م، السبت: ١٠ص - ٤م'
    },
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2478.3089!2d-0.3346!3d51.5908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDM1JzI3LjAiTiAwwrAyMCcwNC42Ilc!5e0!3m2!1sen!2suk!4v1234567890',
    coordinates: { lat: 51.5908, lng: -0.3346 }
  },
  {
    id: 2,
    country: 'Kuwait',
    countryAr: 'الكويت',
    city: 'Kuwait City',
    cityAr: 'مدينة الكويت',
    address: 'Al Hamra Tower, Kuwait City',
    addressAr: 'برج الحمراء، مدينة الكويت',
    phone: '+965 2222 3333',
    whatsapp: '+96522223333',
    email: 'kuwait@harryandjacobs.com',
    flag: '🇰🇼',
    hours: {
      en: 'Sun-Thu: 9:00 AM - 5:00 PM',
      ar: 'الأحد-الخميس: ٩ص - ٥م'
    },
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.8!2d47.9826!3d29.3759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDIyJzMzLjIiTiA0N8KwNTgnNTcuNCJF!5e0!3m2!1sen!2skw!4v1234567890',
    coordinates: { lat: 29.3759, lng: 47.9826 }
  },
  {
    id: 3,
    country: 'Iraq',
    countryAr: 'العراق',
    city: 'Baghdad',
    cityAr: 'بغداد',
    address: 'Karrada District, Baghdad',
    addressAr: 'منطقة الكرادة، بغداد',
    phone: '+964 770 123 4567',
    whatsapp: '+9647701234567',
    email: 'baghdad@harryandjacobs.com',
    flag: '🇮🇶',
    hours: {
      en: 'Sun-Thu: 9:00 AM - 5:00 PM',
      ar: 'الأحد-الخميس: ٩ص - ٥م'
    },
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.2!2d44.3661!3d33.3152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDE4JzU0LjciTiA0NDXCMDE5JzU4LjAiRQ!5e0!3m2!1sen!2siq!4v1234567890',
    coordinates: { lat: 33.3152, lng: 44.3661 }
  },
  {
    id: 4,
    country: 'Saudi Arabia',
    countryAr: 'المملكة العربية السعودية',
    city: 'Riyadh',
    cityAr: 'الرياض',
    address: 'King Fahd Road, Riyadh',
    addressAr: 'طريق الملك فهد، الرياض',
    phone: '+966 11 123 4567',
    whatsapp: '+966111234567',
    email: 'riyadh@harryandjacobs.com',
    flag: '🇸🇦',
    hours: {
      en: 'Sun-Thu: 9:00 AM - 5:00 PM',
      ar: 'الأحد-الخميس: ٩ص - ٥م'
    },
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.8!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1234567890',
    coordinates: { lat: 24.7136, lng: 46.6753 }
  },
  {
    id: 5,
    country: 'United Arab Emirates',
    countryAr: 'الإمارات العربية المتحدة',
    city: 'Dubai',
    cityAr: 'دبي',
    address: 'Business Bay, Dubai',
    addressAr: 'الخليج التجاري، دبي',
    phone: '+971 4 123 4567',
    whatsapp: '+97141234567',
    email: 'dubai@harryandjacobs.com',
    flag: '🇦🇪',
    hours: {
      en: 'Sun-Thu: 9:00 AM - 6:00 PM',
      ar: 'الأحد-الخميس: ٩ص - ٦م'
    },
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.2!2d55.2708!3d25.1871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDExJzEzLjYiTiA1NcKwMTYnMTQuOSJF!5e0!3m2!1sen!2sae!4v1234567890',
    coordinates: { lat: 25.1871, lng: 55.2708 }
  }
];
